export default {
  "app.title": "AICOS",
  "app.tagline": "Finances",
  "nav.dashboard": "Tableau de bord",
  "nav.gl": "Grand livre",
  "nav.ar": "Comptes clients",
  "nav.ap": "Comptes fournisseurs",
  "nav.tax": "Taxes",
  "auth.signIn": "Se connecter",
  "auth.email": "Courriel",
  "auth.password": "Mot de passe",
  "auth.signOut": "Se déconnecter",
  "auth.invalid": "Courriel ou mot de passe invalide",
  "auth.signedInAs": "Connecté en tant que",
  "dashboard.welcome": "Bienvenue dans AICOS",
  "nav.bi": "Facturation",
  "nav.po": "Achats",
  "nav.ex": "Dépenses",
  "nav.entities": "Entités",
  "dashboard.subtitle": "Console opérateur — chaque action de module, reliée à AICOS.",
  "nav.ceo": "Cockpit PDG",
  "nav.cfo": "Coin DAF",
  "kpi.days": "jours",
  "nav.compliance": "Conformité",
  "brand.org": "Lopettia",
  "brand.product": "AICOS",
  "nav.home": "Accueil",
  "app.system": "Système d'exploitation d'entreprise IA",
  "home.selectModule": "Sélectionnez un module",
  "Tour": "Visite guidée",
  "Manual": "Manuel",
  "soon.title": "Bientôt disponible",
  "soon.body": "Cette fonction fait partie du périmètre de parité de l'AICOS hérité et n'est pas encore reliée dans la réécriture Go. Elle reste disponible dans l'AICOS hérité.",
  "mod.ap": "Comptes fournisseurs",
  "mod.ar": "Comptes clients",
  "mod.ex": "Frais de déplacement",
  "hub.journals": "Écritures",
  "hub.reports": "Soldes et rapports",
  "hub.closing": "Clôture",
  "hubd.newJournal": "Créer et modifier des écritures manuelles",
  "hubd.journals": "Comptabiliser, approuver et extourner",
  "hubd.trialBalance": "Soldes des comptes de l'exercice",
  "hubd.statements": "Bilan et compte de résultat",
  "hubd.yearEnd": "Processus de clôture annuelle",
  "hubd.payables": "Saisir et comptabiliser une facture fournisseur",
  "hubd.payablesList": "Factures fournisseurs comptabilisées",
  "hubd.receivables": "Émettre une facture client",
  "hubd.openItems": "Créances en cours",
  "hubd.payment": "Recevoir et appliquer un paiement",
  "hubd.billing": "Émettre une facture de vente avec TPS",
  "hubd.invoices": "Factures de vente émises",
  "hubd.purchasing": "Créer un bon de commande",
  "hubd.orders": "Bons de commande ouverts",
  "hubd.match": "Rapprochement à 3 voies avec CF",
  "hubd.expenses": "Soumettre une note de frais",
  "hubd.expenseList": "Approuver et comptabiliser les notes",
  "kpi.revenue_ytd": "Revenus cumulés",
  "kpi.expenses_ytd": "Charges cumulées",
  "kpi.net_income": "Bénéfice net",
  "kpi.operating_margin_pct": "Marge opérationnelle",
  "kpi.gross_margin_pct": "Marge brute",
  "kpi.cash_position": "Trésorerie",
  "kpi.ar_balance": "Comptes clients",
  "kpi.ap_balance": "Comptes fournisseurs",
  "kpi.gst_net_owing": "TPS nette à payer",
  "kpi.working_capital": "Fonds de roulement",
  "kpi.current_ratio": "Ratio de liquidité",
  "kpi.dso_days": "DMP",
  "kpi.dpo_days": "DMF",
  "kpi.dio_days": "DJS",
  "kpi.ccc_days": "Cycle de conversion de trésorerie",
  "kpi.revenue_mtd": "Revenus du mois",
  "kpi.bills_mtd_count": "Factures du mois",
  "kpi.pipeline_value": "Valeur du pipeline",
  "kpi.concentration_top1_pct": "Concentration du client principal",
  "kpi.active_business_units": "Unités d'affaires actives",
  "kpi.active_users": "Utilisateurs actifs",
  "kpi.risk_score": "Constats d'audit ouverts",
  "kpi.top_customers": "Principaux clients",
  "kpi.geographic_top": "Région principale",
  "dash.openItemsFor": "Postes ouverts — {id}",
  "dash.openFindings": "Constats d'audit ouverts",
  "common.date": "Date",
  "common.currency": "Devise",
  "common.description": "Description",
  "common.amount": "Montant",
  "common.account": "Compte",
  "common.debit": "Débit",
  "common.credit": "Crédit",
  "common.status": "Statut",
  "common.actions": "Actions",
  "common.customer": "Client",
  "common.vendor": "Fournisseur",
  "common.total": "Total",
  "common.calculate": "Calculer",
  "common.result": "Résultat",
  "common.rate": "Taux",
  "common.language": "Langue",
  "common.noData": "Aucune donnée.",
  "common.selectAccount": "Choisir un compte…",
  "common.selectCustomer": "Choisir un client…",
  "common.selectVendor": "Choisir un fournisseur…",
  "common.remove": "Retirer",
  "gl.tab.entry": "Nouvelle écriture",
  "gl.tab.journals": "Écritures",
  "gl.tab.balances": "Soldes",
  "gl.tab.reports": "Rapports",
  "gl.tab.yearend": "Clôture annuelle",
  "gl.yearEnd": "Clôture de fin d'exercice",
  "gl.previewClose": "Aperçu de la clôture",
  "gl.executeClose": "Exécuter la clôture",
  "gl.closingLines": "lignes de clôture",
  "gl.closed": "Exercice {fy} clôturé (écriture {id}).",
  "gl.exportCsv": "Exporter CSV",
  "common.fiscalYear": "Exercice financier",
  "gl.descrPlaceholder": "ex. Revenus de conseil mensuels",
  "gl.addLine": "+ Ajouter une ligne",
  "gl.balanced": "Équilibré",
  "gl.outOfBalance": "Déséquilibre : {diff}",
  "gl.saveDraft": "Enregistrer le brouillon",
  "gl.postJournal": "Comptabiliser",
  "gl.posted": "Écriture {id} comptabilisée.",
  "gl.savedDraft": "Écriture {id} enregistrée en brouillon.",
  "gl.approved": "Écriture {id} approuvée.",
  "gl.col.journal": "Écriture",
  "gl.noJournals": "Aucune écriture. Créez-en une sous « Nouvelle écriture ».",
  "gl.post": "Comptabiliser",
  "gl.approve": "Approuver",
  "gl.reverse": "Contre-passer",
  "gl.reversed": "Écriture {id} contre-passée.",
  "gl.reverseReason": "Motif de la contre-passation (min. 10 caractères)",
  "common.cancel": "Annuler",
  "gl.balancesTitle": "Soldes des comptes (EF {fy})",
  "gl.noBalances": "Aucun solde comptabilisé.",
  "gl.col.debits": "Débits",
  "gl.col.credits": "Crédits",
  "gl.col.balance": "Solde",
  "gl.balanceSheet": "Bilan (EF {fy})",
  "gl.incomeStatement": "Compte de résultat (EF {fy})",
  "gl.assets": "Actifs",
  "gl.totalAssets": "Total des actifs",
  "gl.liabilities": "Passifs",
  "gl.equity": "Capitaux propres",
  "gl.netIncomeYear": "Bénéfice net de l’exercice",
  "gl.totalLiabEquity": "Total passifs et capitaux propres",
  "gl.isBalanced": "✓ Équilibré",
  "gl.notBalanced": "⚠ Déséquilibré",
  "gl.revenue": "Produits",
  "gl.totalRevenue": "Total des produits",
  "gl.expenses": "Charges",
  "gl.totalExpenses": "Total des charges",
  "gl.netIncome": "Bénéfice net",
  "ar.newInvoice": "Nouvelle facture client",
  "ar.createInvoice": "Créer la facture",
  "ar.created": "Facture {id} créée.",
  "ar.openItems": "Postes ouverts",
  "ar.noItems": "Aucun poste ouvert.",
  "ar.openItem": "Poste ouvert",
  "ar.selectItem": "Sélectionner un poste",
  "ar.paymentAmount": "Montant du paiement",
  "ar.cashAccount": "Compte de trésorerie",
  "ar.receivePayment": "Encaisser un paiement",
  "ar.receiveApply": "Encaisser et appliquer",
  "ar.paymentPosted": "Paiement appliqué à {id}.",
  "ar.col.item": "Poste",
  "ar.col.balance": "Solde",
  "ap.enterBill": "Saisir une facture",
  "ap.vendorInvoice": "N° facture fournisseur",
  "ap.expenseAccount": "Compte de charges",
  "ap.enterPost": "Saisir et comptabiliser",
  "ap.posted": "Facture {id} saisie et comptabilisée.",
  "ap.bills": "Factures",
  "ap.noBills": "Aucune facture.",
  "ap.col.voucher": "Pièce",
  "ap.col.gross": "Brut",
  "ap.col.net": "Net",
  "bi.issueInvoice": "Émettre une facture de vente",
  "bi.revenueAccount": "Compte de produits",
  "bi.amountBeforeTax": "Montant (hors taxe)",
  "bi.gst": "TPS/TVH",
  "bi.issue": "Émettre la facture",
  "bi.issued": "Facture {id} émise (comptabilise les produits + ouvre une créance).",
  "bi.invoices": "Factures",
  "bi.noInvoices": "Aucune facture.",
  "bi.col.invoice": "Facture",
  "ex.newReport": "Nouvelle note de frais",
  "ex.employee": "Employé",
  "ex.employeePlaceholder": "Matricule employé",
  "ex.purpose": "Motif",
  "ex.submit": "Soumettre la note",
  "ex.approve": "Approuver",
  "ex.approved": "Rapport {id} approuvé.",
  "ex.post": "Comptabiliser",
  "ex.posted": "Rapport {id} comptabilisé.",
  "ex.submitted": "Note de frais {id} soumise (approuver, puis comptabiliser sous Écritures).",
  "ex.reports": "Notes de frais",
  "ex.noReports": "Aucune note de frais.",
  "ex.col.report": "Note",
  "ex.col.reimbursable": "Remboursable",
  "po.newOrder": "Nouveau bon de commande",
  "po.quantity": "Quantité",
  "po.unitPrice": "Prix unitaire",
  "po.create": "Créer le bon",
  "po.created": "Bon de commande {id} créé.",
  "po.orders": "Bons de commande",
  "po.noOrders": "Aucun bon de commande.",
  "po.receive": "Recevoir",
  "po.received": "Réception des marchandises pour le BC {po}.",
  "po.noLines": "Ce BC n%a pas de lignes.'",
  "po.col.po": "Bon",
  "po.col.match": "Rapprochement",
  "po.threeWayMatch": "Rapprochement à 3 voies",
  "po.matchResult": "Bon {po} : {status}.",
  "ent.title": "Données de référence",
  "ent.chartOfAccounts": "Plan comptable",
  "ent.customers": "Clients",
  "ent.vendors": "Fournisseurs",
  "ent.currencies": "Devises",
  "ent.provinces": "Provinces",
  "ent.noRows": "Aucune ligne.",
  "ent.new": "Nouvel enregistrement",
  "ent.create": "Créer",
  "ent.created": "Enregistrement créé.",
  "ent.delete": "Supprimer",
  "ent.deleted": "Enregistrement supprimé.",
  "ent.confirmDelete": "Supprimer cet enregistrement?",
  "ent.grp.master": "Données de base",
  "ent.grp.collections": "Recouvrement clients",
  "ent.grp.expense": "Détail des dépenses",
  "ent.grp.compliance": "Conformité & divulgation",
  "ent.arWriteoffs": "Radiations clients",
  "ent.arAllowance": "Provision clients (CECL)",
  "ent.dunning": "Lettres de relance",
  "ent.travelAuth": "Autorisations de voyage",
  "ent.cashAdvance": "Avances de fonds",
  "ent.auditFindings": "Constats d'audit interne",
  "ent.legalHold": "Obligations de conservation",
  "ent.consolidation": "Éliminations de consolidation",
  "tax.title": "Taxes — Canada (Alberta)",
  "tax.tab.gst": "Calculateur TPS",
  "tax.tab.return": "Déclaration TPS/TVH",
  "tax.tab.rates": "Taux",
  "tax.calcTitle": "Calculer la TPS/TVH",
  "tax.amountBeforeTax": "Montant (hors taxe)",
  "tax.province": "Province",
  "tax.transaction": "Transaction",
  "tax.txSale": "Vente (percevoir la TPS)",
  "tax.txPurchase": "Achat (crédit de taxe sur les intrants)",
  "tax.supply": "Fourniture",
  "tax.domestic": "Intérieure",
  "tax.export": "Exportation vers un non-résident",
  "tax.taxClass": "Catégorie de taxe",
  "tax.itc": "Crédit de taxe sur les intrants",
  "tax.yes": "Oui (récupérable)",
  "tax.no": "Non",
  "tax.returnTitle": "Déclaration TPS/TVH",
  "tax.english": "Anglais",
  "tax.french": "Français",
  "tax.line": "Ligne {n} — {label}",
  "tax.netTax": "Taxe nette",
  "tax.ratesTitle": "Taux de taxe de vente canadiens",
  "tax.col.gstHst": "TPS/TVH",
  "tax.col.pst": "TVP",
  "tax.col.type": "Type",
  "comp.amount": "Montant",
  "comp.grossAmount": "Montant brut",
  "comp.province": "Province",
  "comp.transaction": "Transaction",
  "comp.supply": "Fourniture",
  "comp.class": "Catégorie",
  "comp.concept": "Concept",
  "comp.municipality": "Municipalité",
  "comp.taxableIncome": "Revenu imposable",
  "comp.tariff": "Tarif",

  // ── Hub card titles + module subtitles (keyed by English string) ──
  "Configuration": "Configuration",
  "Journals": "Écritures",
  "Reconciliation": "Rapprochement",
  "Multi-currency": "Multidevise",
  "Consolidation": "Consolidation",
  "Closing": "Clôture",
  "Reports": "Rapports",
  "Inquiries": "Consultations",
  "Puerto Rico": "Porto Rico",
  "Administration": "Administration",
  "Vendors": "Fournisseurs",
  "Vouchers": "Pièces (factures)",
  "Payments": "Paiements",
  "Withholding": "Retenues",
  "Customers": "Clients",
  "Pending Items": "Postes en attente",
  "Adjustments": "Ajustements",
  "Collections": "Recouvrement",
  "Items": "Articles",
  "Requisitions": "Demandes d'achat",
  "Quotations (RFQ)": "Soumissions (DDP)",
  "Purchase Orders": "Bons de commande",
  "Receiving": "Réception",
  "Contracts": "Contrats",
  "Budget": "Budget",
  "My Expenses (Self-Service)": "Mes dépenses (libre-service)",
  "Delegated Entry": "Saisie déléguée",
  "Approvals": "Approbations",
  "Accounting": "Comptabilité",
  "Processes": "Traitements",
  "Consolidated Invoices": "Factures consolidées",
  "WorkCenter": "WorkCenter",
  "Invoices": "Factures",
  "Multi-ledger chart of accounts, journals with approval, multicurrency, consolidation and close.": "Plan comptable multi-grand-livre, écritures avec approbation, multidevise, consolidation et clôture.",
  "Vendors, vouchers with 3-way match, pay cycles, withholding (PR Sec. 1062 + Form 480 + US 1099). Automatic GL integration.": "Fournisseurs, pièces avec rapprochement à 3 voies, cycles de paiement, retenues (PR Sec. 1062 + Formulaire 480 + US 1099). Intégration GL automatique.",
  "Customers shared with BI, pending items, deposits and application worksheets, aging and dunning. Zero re-entry.": "Clients partagés avec la facturation, postes en attente, dépôts et feuilles d'imputation, âge et relances. Zéro ressaisie.",
  "Bill types, charge codes with classified IVU (PR), bill cycles, entry and auto-bill-to-AR. SURI integration ready.": "Types de facture, codes de charge avec IVU classé (PR), cycles de facturation, saisie et facturation-auto vers CC. Prêt pour SURI.",
  "Requisitions, purchase orders, receipts, contracts. 3-way match with AP. Integrated Req→PO→Receipt→Voucher flow.": "Demandes d'achat, bons de commande, réceptions, contrats. Rapprochement à 3 voies avec CF. Flux intégré DA→BC→Réception→Pièce.",
  "Travel Auth, Cash Advance, Expense Report with approval and audit. Integrates GL, AP and corporate card.": "Autorisation de voyage, avance de fonds, note de frais avec approbation et audit. Intègre GL, CF et carte d'entreprise.",

  // ── CEO / CFO cockpits ──
  "Strategic view · 8 KPIs · click a tile to drill down.": "Vue stratégique · 8 KPI · cliquez une tuile pour explorer.",
  "Financial view · 12 KPIs · working capital + close + SOX + tax.": "Vue financière · 12 KPI · fonds de roulement + clôture + SOX + fiscalité.",
  "Strategic": "Stratégique",
  "Close Calendar": "Calendrier de clôture",
  "Working Capital": "Fonds de roulement",
  "Current Ratio": "Ratio de liquidité",
  "P&L vs Budget": "Résultat vs budget",
  "13-Week Cash": "Trésorerie 13 semaines",
  "Tax Provision": "Provision d'impôt",
  "SOX Status": "Statut SOX",
  "AR Aging": "Âge des CC",
  "AP Aging": "Âge des CF",
  "Material Weakness": "Faiblesse importante",
  "target": "cible",
  "Click for detail": "Cliquer pour le détail",
  "Period insights (auto-generated)": "Constats de la période (auto-générés)",
  "All key indicators within target.": "Tous les indicateurs clés dans la cible.",
  "AR Aging Distribution": "Répartition de l'âge des CC",
  "Current": "Courant",
  "Close accounting actions": "Actions comptables de clôture",
  "Revenue billed this month": "Produits facturés ce mois",
  "(Revenue − OpEx) / Revenue, YTD": "(Produits − charges d'exploitation) / Produits, cumul",
  "Net cash + banks": "Trésorerie nette + banques",
  "Cash + operating banks (1010/1020)": "Encaisse + banques d'exploitation (1010/1020)",
  "Open purchase-order commitments": "Engagements de bons de commande ouverts",
  "Leading indicator of future spend": "Indicateur avancé des dépenses futures",
  "Top 5 by open balance": "Top 5 par solde ouvert",
  "<30% concentration": "<30 % concentration",
  "No AR balances": "Aucun solde CC",
  "Leading SetID by revenue (geographic mix)": "SetID dominant par produits (mix géographique)",
  "No data": "Aucune donnée",
  "Open internal-audit findings": "Constats d'audit interne ouverts",
  "<5 · 0 MW": "<5 · 0 FI",
  "Operating footprint + active users": "Empreinte opérationnelle + utilisateurs actifs",
  "Active business units and system users": "Unités d'affaires actives et utilisateurs du système",
  "Fiscal-year close progress": "Avancement de la clôture de l'exercice",
  ">90% at close": ">90 % à la clôture",
  "(AR / Revenue YTD) × 365": "(CC / Produits cumulés) × 365",
  "<45 days": "<45 jours",
  "Days payable outstanding": "Délai de paiement fournisseurs",
  "30–60 days": "30–60 jours",
  "Cash conversion cycle": "Cycle de conversion de trésorerie",
  "<30 days": "<30 jours",
  "Current assets − current liabilities": "Actif courant − passif courant",
  "Short-term liquidity buffer": "Coussin de liquidité à court terme",
  "Current assets / current liabilities": "Actif courant / passif courant",
  "Liquidity coverage": "Couverture de liquidité",
  "No budget ledger loaded": "Aucun grand-livre budgétaire chargé",
  "Actual vs BUDGET ledger": "Réel vs grand-livre BUDGET",
  "Net inflows − outflows, 13 weeks": "Entrées − sorties nettes, 13 semaines",
  "Short-term treasury forecast": "Prévision de trésorerie à court terme",
  "Effective tax rate — not loaded": "Taux d'imposition effectif — non chargé",
  "ETR from tax provision": "TIE de la provision d'impôt",
  "{closed} / {total} findings closed": "{closed} / {total} constats fermés",
  "Internal-audit remediation": "Correction d'audit interne",
  ">90% · 0 MW": ">90 % · 0 FI",
  "Receivables overdue > 60 days": "CC en souffrance > 60 jours",
  "CECL provision rises on +60d": "La provision CECL augmente au-delà de 60 j",
  "Payables overdue > 60 days": "CF en souffrance > 60 jours",
  "Vendor & legal risk on +60d": "Risque fournisseur et juridique au-delà de 60 j",
  "SOX 404 disclosure": "Divulgation SOX 404",
  "None identified": "Aucune relevée",
  "SOX §404 material weaknesses": "Faiblesses importantes SOX §404",
  "YTD {ytd} · {n} invoices": "Cumul {ytd} · {n} factures",
  "Rev {rev} − Exp {exp}": "Prod. {rev} − Charges {exp}",
  "#1 {id} · {pct}% of total AR": "#1 {id} · {pct} % du total CC",
  "{rev} leading region": "{rev} région dominante",
  "{n} Material Weakness — SOX 404": "{n} faiblesse importante — SOX 404",
  "{n} open findings": "{n} constats ouverts",
  "{n} / 12 periods closed": "{n} / 12 périodes clôturées",
  "AR {ar} / Rev YTD": "CC {ar} / Prod. cumul",
  "AP {ap} / COGS est.": "CF {ap} / coût des ventes est.",
  "DSO {dso} + DIO {dio} − DPO {dpo}": "DSO {dso} + DIO {dio} − DPO {dpo}",
  "Operating margin {pct}% below the sector benchmark (>20%). Review operating expense.": "Marge d'exploitation {pct} % sous la référence du secteur (>20 %). Réviser les charges d'exploitation.",
  "Top-1 customer concentration {pct}% > 30% — single-customer dependence risk.": "Concentration du 1er client {pct} % > 30 % — risque de dépendance à un seul client.",
  "{n} Material Weakness identified — 10-K SOX 404 disclosure required.": "{n} faiblesse importante relevée — divulgation 10-K SOX 404 requise.",
  "Cash position {amt} below the $50K threshold — activate a 13-week forecast.": "Position de trésorerie {amt} sous le seuil de 50 K$ — activer une prévision sur 13 semaines.",
  "Pipeline {pl} > Revenue YTD {rev} — strong leading indicator.": "Pipeline {pl} > Produits cumulés {rev} — fort indicateur avancé.",
  "DSO {n}d above the 45-day target — accelerate collections.": "DSO {n}j au-dessus de la cible de 45 jours — accélérer le recouvrement.",
  "Cash conversion cycle {n}d above the 30-day target — working capital tied up in operations.": "Cycle de conversion de trésorerie {n}j au-dessus de la cible de 30 jours — fonds de roulement immobilisé.",
  "Negative cash conversion cycle ({n}d) — operations financed by suppliers. Strong position.": "Cycle de conversion de trésorerie négatif ({n}j) — opérations financées par les fournisseurs. Position solide.",
  "Current ratio {n} below 1.0 — current liabilities exceed current assets; liquidity watch.": "Ratio de liquidité {n} sous 1,0 — le passif courant dépasse l'actif courant; surveillance de liquidité.",
  "{n} Material Weakness open — 10-K SOX 404 disclosure required.": "{n} faiblesse importante ouverte — divulgation 10-K SOX 404 requise.",
  "{amt} of receivables overdue >60 days — CECL provision rises sharply on these buckets.": "{amt} de CC en souffrance >60 jours — la provision CECL augmente fortement sur ces tranches.",
  "Period-end AP accrual": "Charge à payer CF de fin de période",
  "Identify receipts without a voucher; create an auto-reversing accrual journal.": "Repérer les réceptions sans pièce; créer une écriture de régularisation à contre-passation automatique.",
  "Revenue accrual (BI/AR)": "Produits à recevoir (Fact./CC)",
  "Bills invoiced for future service → deferred-revenue journal (2210).": "Factures émises pour service futur → écriture de produits différés (2210).",
  "Subledger vs GL reconciliation": "Rapprochement sous-livre vs GL",
  "Compare AR/AP/Bank subledger to GL; report variances > $0.01.": "Comparer le sous-livre CC/CF/Banque au GL; signaler les écarts > 0,01 $.",
  "Bank reconciliation (BAI2)": "Rapprochement bancaire (BAI2)",
  "Import a BAI2 statement; match payments; update RECONCILED_FLAG.": "Importer un relevé BAI2; rapprocher les paiements; mettre à jour RECONCILED_FLAG.",
  "Year-end close": "Clôture de fin d'exercice",
  "Close P&L; zero-out I/E accounts to Retained Earnings (3110).": "Clôturer le résultat; solder les comptes de produits/charges vers les bénéfices non répartis (3110).",
  "PR regulatory reporting": "Déclarations réglementaires PR",
  "SC 2918 (monthly IVU), SC 2070 (480.6 withholding), SURI returns.": "SC 2918 (IVU mensuel), SC 2070 (retenue 480.6), déclarations SURI.",
  "SoD exceptions": "Exceptions de SdT",
  "Users with segregation-of-duties conflicts in the period, for internal audit.": "Utilisateurs en conflit de séparation des tâches dans la période, pour l'audit interne.",

  // ── WorkCenter ──
  "Consolidated panel · work queues, quick links and period summary.": "Panneau consolidé · files de travail, liens rapides et résumé de la période.",
  "My Work": "Mon travail",
  "Budget Exceptions": "Exceptions budgétaires",
  "Pending Approval": "En attente d'approbation",
  "ChartField Requests": "Demandes de ChartField",
  "Pending Reconciliations": "Rapprochements en attente",
  "Errors (Edit)": "Erreurs (Édition)",
  "Quick Links": "Liens rapides",
  "Period Summary": "Résumé de la période",
  "No pending journals.": "Aucune écriture en attente.",
  "No budget exceptions.": "Aucune exception budgétaire.",
  "No journals pending your approval.": "Aucune écriture en attente de votre approbation.",
  "No pending changes.": "Aucun changement en attente.",
  "No accounts assigned.": "Aucun compte assigné.",
  "No errors.": "Aucune erreur.",
  "Total journals": "Total des écritures",
  "Posted": "Comptabilisées",
  "Draft / In Edit": "Brouillon / En édition",
  "With errors": "En erreur",
  "+ New Journal": "+ Nouvelle écriture",
  "Journals Inbox": "Boîte de réception des écritures",
  "Ledger Inquiry": "Consultation du grand-livre",
  "Accounting Periods": "Périodes comptables",
  "Import Journals (Excel)": "Importer des écritures (Excel)",
  "User Manual": "Manuel de l'utilisateur",

  // ── GL hub link names + descriptions ──
  "Business Units": "Unités d'affaires",
  "Create and maintain Business Units": "Créer et gérer les unités d'affaires",
  "Accounting Ledgers": "Grands-livres comptables",
  "Define ledgers and ledger groups": "Définir les grands-livres et leurs groupes",
  "Chart of Accounts": "Plan comptable",
  "Create and maintain accounts": "Créer et gérer les comptes",
  "ChartFields": "ChartFields",
  "Accounting dimensions configuration": "Configuration des dimensions comptables",
  "Fiscal Calendars": "Calendriers fiscaux",
  "Accounting periods definition": "Définition des périodes comptables",
  "Exchange Rates": "Taux de change",
  "Exchange rate tables and revaluation": "Tables de taux de change et réévaluation",
  "Journal Sources": "Sources d'écriture",
  "Journal Source definitions": "Définitions des sources d'écriture",
  "Journal Classes": "Classes d'écriture",
  "Accounting journal types and classes": "Types et classes d'écriture comptable",
  "Approval Options": "Options d'approbation",
  "Journal authorization workflow": "Flux d'autorisation des écritures",
  "Journal Entry": "Saisie d'écriture",
  "Create and edit manual journals": "Créer et modifier des écritures manuelles",
  "Standard Journals": "Écritures types",
  "Recurring journals and templates": "Écritures récurrentes et modèles",
  "Import Journals": "Importer des écritures",
  "Bulk load from flat file or Excel": "Chargement en lot depuis un fichier plat ou Excel",
  "Edit Journals": "Modifier les écritures",
  "Validation process (Edit)": "Processus de validation (Édition)",
  "Post Journals": "Comptabiliser les écritures",
  "Posting process": "Processus de comptabilisation",
  "Unpost Journals": "Décomptabiliser les écritures",
  "Posting reversal": "Contre-passation de comptabilisation",
  "Approve Journals": "Approuver les écritures",
  "Approval inbox": "Boîte d'approbation",
  "Journal Inquiry": "Consultation des écritures",
  "Search and inquire journals": "Rechercher et consulter les écritures",
  "Configure Rules": "Configurer les règles",
  "Account reconciliation rules": "Règles de rapprochement des comptes",
  "Reconciliation Workbench": "Atelier de rapprochement",
  "Interactive reconciliation management": "Gestion interactive du rapprochement",
  "Create Reconciliations": "Créer des rapprochements",
  "Generate reconciliations": "Générer des rapprochements",
  "Revaluation": "Réévaluation",
  "FX balance revaluation process": "Processus de réévaluation des soldes en devises",
  "Translation": "Conversion",
  "Ledger translation process": "Processus de conversion du grand-livre",
  "Average Balances": "Soldes moyens",
  "ADB (Average Daily Balance) calculation": "Calcul du solde quotidien moyen (ADB)",
  "Configure Consolidation": "Configurer la consolidation",
  "Trees, scopes, eliminations": "Arbres, périmètres, éliminations",
  "Execute Consolidation": "Exécuter la consolidation",
  "Consolidation process": "Processus de consolidation",
  "Consolidation Dashboard": "Tableau de bord de consolidation",
  "Process monitoring": "Suivi des traitements",
  "Closing Rules": "Règles de clôture",
  "Closing rules configuration": "Configuration des règles de clôture",
  "Interim Close": "Clôture intermédiaire",
  "Monthly period close": "Clôture de période mensuelle",
  "Year-End Close": "Clôture de fin d'exercice",
  "Fiscal year-end close": "Clôture de l'exercice fiscal",
  "Undo Close": "Annuler la clôture",
  "Close reversal": "Contre-passation de clôture",
  "Balance Sheet": "Bilan",
  "Statement of Financial Position": "État de la situation financière",
  "Income Statement": "État des résultats",
  "Profit & Loss report": "Rapport de profits et pertes",
  "Cash Flow": "Flux de trésorerie",
  "Statement of Cash Flows": "État des flux de trésorerie",
  "Trial Balance": "Balance de vérification",
  "General Trial Balance": "Balance de vérification générale",
  "General Ledger": "Grand livre",
  "Account movement detail": "Détail des mouvements de compte",
  "Accounting Journals": "Écritures comptables",
  "Journal listing and detail": "Liste et détail des écritures",
  "Interactive balances by dimension": "Soldes interactifs par dimension",
  "Posted journal detail": "Détail des écritures comptabilisées",
  "Period Comparison": "Comparaison de périodes",
  "Period-over-period balance comparison": "Comparaison de soldes d'une période à l'autre",
  "PR Compliance Hub": "Centre de conformité PR",
  "IVU · 480 · License · CRIM · Act 60": "IVU · 480 · Licence · CRIM · Loi 60",
  "SC 2918 — Monthly IVU": "SC 2918 — IVU mensuel",
  "Monthly sales-tax return to Hacienda": "Déclaration mensuelle d'IVU à Hacienda",
  "Form 480.20 Corp": "Formulaire 480.20 Corp",
  "Income tax + surtax + AMT": "Impôt sur le revenu + surtaxe + AMT",
  "Form 480.6 A/B/C": "Formulaire 480.6 A/B/C",
  "Annual withholding informational returns": "Déclarations de renseignements annuelles sur les retenues",
  "Municipal License": "Licence municipale",
  "Form 2A annual per municipality": "Formulaire 2A annuel par municipalité",
  "CRIM AS-29": "CRIM AS-29",
  "Personal and real property": "Biens meubles et immeubles",
  "Schedule M-1": "Annexe M-1",
  "Book/tax reconciliation": "Rapprochement comptable/fiscal",
  "Act 60 Decrees": "Décrets Loi 60",
  "Compliance + annual fee tracking": "Conformité + suivi des frais annuels",
  "Filings Audit Trail": "Piste d'audit des dépôts",
  "Tamper-evident history": "Historique inviolable",
  "Open/Close Periods": "Ouvrir/fermer les périodes",
  "Period opening control": "Contrôle d'ouverture des périodes",
  "Process Monitor": "Moniteur de traitements",
  "Batch process status": "Statut des traitements par lots",
  "Audit Logs": "Journaux d'audit",
  "Change and access history": "Historique des changements et accès",
} as Record<string, string>;
